const SET_TOKEN = "setToken"
const GET_TOKEN = "getToken"
const SET_USERNAME = "setUserName"
export { SET_TOKEN, GET_TOKEN, SET_USERNAME }